<kendo-dialog title="Add Tier" (close)="onCancel()">
  <kendo-label>Price Tier Name:</kendo-label>
  <kendo-textbox
    [maxlength]="maxLength"
    [(ngModel)]="tierName"
    placeholder="Price Tier 1"
    (valueChange)="
      charactersCount = $event.length;
      counter = charactersCount + '/' + maxLength
    "
  >
  </kendo-textbox>
  <div class="text-container">
    <p class="small-text thin-text subtle-text">Up to 25 characters</p>
    <p class="small-text thin-text subtle-text">{{ counter }}</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">Cancel</button>
    <button
      kendoButton
      [disabled]="!tierName"
      (click)="onAccept()"
      themeColor="primary"
    >
      Add
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
